/* eslint-disable react/no-danger */
import classNames from 'classnames';
import { FC } from 'react';

import { cleanBuilderStringInput } from '../../text';

interface Props {
  title?: string;
  className?: string;
}

export const Title: FC<Props> = ({ title, className }) => {
  if (!title) return null;
  return (
    <h1
      className={classNames('u-typography-h1', className)}
      dangerouslySetInnerHTML={{ __html: cleanBuilderStringInput(title) }}
    />
  );
};
